import styled from 'styled-components';

import { CelluarInput } from 'components/uikit/CelluarInput/CelluarInput';
import { Button } from 'components/uikit/Button/Button';

export const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: space-between;
`;

export const Input = styled(CelluarInput)`
  width: 100%;
  margin-bottom: 15px;
`;

export const StyledButton = styled(Button).attrs({ size: 'm' })`
  width: 100%;
`;
